<div class="tabs-container" [ngClass]="'tabs-container--' + variant()">
  <div class="tabs-header">
    <button
      *ngFor="let tab of tabs()"
      [ngClass]="{
        'tab-button': true,
        'tab-button--active': isTabActive(tab.id),
        'tab-button--disabled': tab.disabled
      }"
      [disabled]="tab.disabled"
      (click)="selectTab(tab.id)"
    >
      {{ tab.label }}
    </button>
  </div>
  <div class="tabs-content" [ngClass]="{ 'tabs-content--animate': animating() }">
    <ng-content></ng-content>
  </div>
</div>
